import { useCallback, useContext, useMemo } from 'react';
import { FormikHelpers } from 'formik';
import { message } from 'antd';

import { StatusesService } from '../../services';
import { CreateStatusMapper } from '../../mappers';
import { IStatusFormValues } from '../../interfaces';
import { CreateStatusContext } from '../../context';
import { useStatusById } from './use-status-by-id';

const emptyValues: IStatusFormValues = {
  name: '',
  nameEn: '',
  parentId: '',
  modelId: '',
  description: '',
};

export const useStatusForm = () => {
  const { id, onSucceed } = useContext(CreateStatusContext);

  const status = useStatusById(id, { enabled: !!id });

  const initialValues = useMemo<IStatusFormValues | undefined>(() => {
    if (id) {
      return status.data ? CreateStatusMapper.toDomain(status.data) : undefined;
    }
    return emptyValues;
  }, [status.data, id]);

  const onSubmit = useCallback(
    async (values: IStatusFormValues, helpers: FormikHelpers<IStatusFormValues>) => {
      helpers.setStatus(null);

      const result = await StatusesService.save(values);

      if (result.status === 200) {
        onSucceed?.();
      } else if (result.status === 422) {
        helpers.setErrors(result.data as Record<string, string>);
      } else {
        message.error(result.data as string);
      }

      helpers.setSubmitting(false);
    },
    [onSucceed],
  );

  return { initialValues, onSubmit, id };
};
